module.exports = __webpack_public_path__ + "static/img/个人中心@4x.60dadf14.png";